import { useQuery } from '@abyss/web/hooks/useQuery';
// @ts-ignore
import { ApiUrl } from '@src/common/ajax/apiUrl';
import GetUpdateRoles from './GetUpdateRoles.gql';

export const useUpdateRoles = (options) => {
  return useQuery(GetUpdateRoles, {
    ...options,
    url: ApiUrl.graphQl(),
    requestPolicy: 'no-cache',
  });
};
